import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import {ILocker2} from "@/model/Locker/lockerInterfaces";
import responseHandler from "@/plugins/errorHandling";

interface Locker2State {
  // lockers: IShortLocker[];
  locker: ILocker2;
  errors: IErrors;
}

const state: Locker2State = {
  // lockers: [],
  locker: {} as ILocker2,
  errors: {},
};


const getters: GetterTree<Locker2State, RootState> = {
  // lockers: (state): IShortLocker[] => state.lockers,
  locker: (state) => state.locker || {} as ILocker2,
  errors: (state) => state.errors,
};

const actions: ActionTree<Locker2State, RootState> = {
  fetchLocker2: ({ commit }, lockerId): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers2/' + lockerId
    }),
    commit,
    'locker2Loaded'
  ),
  createTransferDestination: ({commit}, {lockerId, destinationId}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers/' + lockerId + '/transferDestinations/' + destinationId,
      method: 'PUT',
    }),
    commit,
    'transferDestinationsLoaded'
  ),
  setFeature: ({ commit }, {lockerId, data}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers/' + lockerId + '/features',
      method: 'POST',
      data: data
    }),
    commit,
    'locker2FeatureToggled',
  ),
  commitLockerCompanyIds: ({commit}, lockerCompanyIds: number[]): any => {
    commit('lockerCompanyIdsCommitted', lockerCompanyIds);
  },
  setLandingVersion: ({ commit }, {lockerId, landing}): any => responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'lockers/' + lockerId + '/landing/' + landing,
        method: 'PUT',
      }),
      commit,
      'lockerLandingVersionSet',
  ),
  setScreenType: ({ commit }, {lockerId, orientation, resolution}): any => responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'lockers/' + lockerId + '/rotate-screen',
        method: 'POST',
        data: {orientation, resolution},
      }).then((response): any => ({
        ...response,
        data: {data: {orientation, resolution, applied: true}},
      })),
      commit,
      'lockerScreenConfigSet',
  ),
  updateLocker: ({ commit }, {lockerId, data}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers/' + lockerId,
      method: 'PATCH',
      data: data,
    }),
    commit,
    'locker2Loaded'
  ),
  updateSim: ({ commit }, {lockerId, sim}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers/' + lockerId + '/sim',
      method: 'PUT',
      data: { sim },
    }),
    commit,
    'lockerSimUpdated',
  ),
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },
  clearErrors: ({commit}): any => commit('cleanErrors'),
};

const mutations: MutationTree<Locker2State> = {
  locker2Loaded(state, payload: ILocker2) {
    state.locker = payload;
  },
  transferDestinationsLoaded(state, payload: any) {
    state.locker = payload;
  },
  locker2FeatureToggled(state, payload: ILocker2) {
    // I have to do an assign as data format is slightly different (setFeature and locker2 are different formats)
    // applying everything from the old format will pollute the entity but that should not be a problem as those
    //  data will never be referred (using ILocker2 typehint would cause compile errors)
    // (and, I cannot just change the transformer in BE as it is used in the locker feature list too)
    // state.locker = payload;
    Object.assign(state.locker, payload);
  },
  lockerCompanyIdsCommitted(state, payload: number[]) {
    if (state.locker) {
      state.locker.lockerCompanyIds = payload;
    }
  },
  lockerLandingVersionSet(state, payload) {
    // @see locker2FeatureToggled
    Object.assign(state.locker, {landing_version: payload});
  },
  lockerScreenConfigSet(state, payload) {
    // @see locker2FeatureToggled
    Object.assign(state.locker, {screenConfig: payload});
  },
  lockerSimUpdated(state, payload: any) {
    Object.assign(state.locker, payload);
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
  cleanErrors(state) {
    state.errors = {};
  },
};

const namespaced: boolean = true;

export const locker2Module: Module<Locker2State, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
